import BaseRepository from '@/baseRepository/BaseRepository';
const resource = '/api/v1/merchantdelegations';

export default {
  createMerchantDelegation(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  deleteMerchantDelegation(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  editMerchantDelegation(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${id}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantDelegationById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/by-merchant`, {
      baseURL,
      headers,
      params,
    });
  },
  getMerchantDelegations(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/by-merchant`, {
      baseURL,
      headers,
      params,
    });
  },
  disableMerchantDelegation(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/disable`, {}, {
      baseURL,
      headers,
      params,
    });
  },
  enableMerchantDelegation(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/enable`, {}, {
      baseURL,
      headers,
      params,
    });
  },
};